import React, {
  useState, useEffect, useReducer,
} from 'react';
import PropTypes from 'prop-types';
import {
  CurrencyInput, Label, Tooltip, TooltipButton, IconInfo,
} from '@americanexpress/dls-react';

import { parseHtml } from '../../utils/util';
import { validateDlsInput } from '../../Validations/Validations';
import { calculatorDlsInput } from '../Calculations/Calculation';

const getVal = require('lodash/get');
// import Tooltip from './Tooltip';

/**
 * returns DLS currency component
 * @param {*} props
 */
const Currency = ({
  fieldValidation,
  cssProperties,
  fieldLabel,
  fieldId,
  filledFormData,
  fieldPlaceholder,
  onElementChange = [],
  handleOnChangeEvents,
  setCurrencySymbol,
  fieldValue = null,
  getValue,
  selectKey,
  preFilledWith,
  isPreFilled,
  fetchUrl,
  validations = [],
  setValidationErrors,
  validationErrors,
  setFocus,
  fieldRank,
  extractMapResponseValueByKey,
  dataObject,
}) => {
  const [value, setValue] = useState();
  const [fieldIdValue, setFieldIdValue] = useState('');
  const currencyVal = fieldValidation.currencyUnit ? fieldValidation.currencyUnit : 'USD';
  const localeVal = fieldValidation.localeVal ? fieldValidation.localeVal : 'en-US';
  const placeholderVal = fieldPlaceholder || '0.00';
  const [validationErrState, dispatchErrState] = useReducer((prevState, payload) => ({ ...prevState, ...payload }), { validationErr: '', isValid: true });
  let dlsClass;

  if (fieldValidation.bgColor) {
    dlsClass = `${fieldValidation.bgColor}`;
  }

  const changeHandler = (e) => {
    const inputVal = e.target.value;
    setValue(inputVal);
    if (onElementChange.length > 0) {
      handleOnChangeEvents(onElementChange, e);
    }
    if (getValue) getValue(inputVal);
  };

  useEffect(() => {
    setFieldIdValue(fieldId);
  }, [fieldId]);

  useEffect(() => {
    if (fieldId !== fieldIdValue) setValue('');
    if (filledFormData && filledFormData[fieldId]) {
      setValue(filledFormData[fieldId]);
    }
  }, [fieldId]);

  useEffect(() => {
    // set currency symbol in formSubmissionData
    if (fieldLabel && fieldLabel.currencySymbol) setCurrencySymbol(fieldLabel.currencySymbol);
    if (isPreFilled && preFilledWith === 'filledFormData' && !fetchUrl) {
      if (filledFormData) {
        // preFilledVal = filledFormData[selectKey];
        setValue(getVal(filledFormData, selectKey));
      }
    } else if (fieldValue !== 'default' && fieldValue !== '') {
      // preFilledVal = fieldValue;
      setValue(fieldValue);
    }
    if (fieldValidation.isFieldDerived) {
      const input = document.querySelector(`#${fieldId}`);
      const processedFields = fieldValidation.requiredFields.map((field) => {
        let dynamicResult = 'false';
        if (field.dynamicOperation) {
          dynamicResult = extractMapResponseValueByKey(field, 'dynamicOperation');
        }
        return { ...field, dynamicResult };
      });
      const temp = calculatorDlsInput({
        requiredFields: processedFields,
        filledFormData,
      });
      if (fieldValidation.changeBackgroundColor) {
        if (temp < 0) {
          input.style.backgroundColor = 'rgba(243, 151, 151, 0.8)';
        } else {
          input.style.backgroundColor = 'rgba(157, 202, 161, 0.8)';
        }
      }
      if (!Number.isNaN(temp) && temp !== Number.parseFloat(value)) {
        const syntheticEvent = {
          target: {
            value: `${temp}`,
            id: fieldId,
          },
        };
        changeHandler(syntheticEvent);
      }
    }
  }, [filledFormData]);

  useEffect(() => {
    // validationErr also can change multiple times, so need one isValid
    if (validationErrState.isValid && validationErrors[fieldRank]) {
      delete validationErrors[fieldRank];
      setValidationErrors({ ...validationErrors });
    } else if (!validationErrState.isValid) {
      setValidationErrors({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    }
  }, [validationErrState.isValid]);

  const validateInput = (e) => {
    const inputVal = e.target.value;
    if (validations.length > 0) {
      const invalidMsg = validateDlsInput(inputVal, validations, dataObject);
      if (invalidMsg) {
        dispatchErrState({ validationErr: `${invalidMsg}`, isValid: false });
      } else {
        dispatchErrState({ validationErr: '', isValid: true });
      }
    }
  };
  const invalidHandler = (e) => {
    if (validations.length > 0) {
      e.preventDefault();
      validateInput(e);
      setFocus({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
    }
  };

  const handleOnKeyDown = (e) => {
    // if fieldValidation.showFractions is false then we should not allow user to enter '.'
    if (fieldValidation && fieldValidation.showFractions === false && e.key === '.') {
      e.preventDefault();
    }
  };

  return (
    <div className={cssProperties.style}>
      <Label htmlFor={fieldId}>
        {parseHtml(fieldLabel.label)}
        {!fieldValidation.required && fieldValidation.optionalLabel && (
          <span
            className={fieldLabel.cssProperties.style}
          >
            {fieldValidation.optionalLabel}
          </span>
        )}
        {fieldValidation && fieldValidation.isToolTip
          && (
            <Tooltip id="ToolTip" triggerElement={<TooltipButton icon={<IconInfo size="sm" title="info" />} />}>{parseHtml(fieldValidation.toolTipInfo)}</Tooltip>
          )}
      </Label>
      {fieldLabel
        && fieldLabel.subLabel
        && (
          <div>
            <label className={fieldLabel.cssProperties.subLabelStyle} htmlFor={fieldId}>
              {parseHtml(fieldLabel.subLabel)}
            </label>
          </div>
        )}
      <CurrencyInput
        defaultValue={value}
        id={fieldId}
        name={fieldId}
        currency={currencyVal}
        locale={localeVal}
        placeholder={placeholderVal}
        label={fieldLabel.label}
        onBlur={changeHandler}
        onChange={validateInput}
        onInvalid={invalidHandler}
        className={dlsClass}
        required={fieldValidation.required}
        disabled={fieldValidation.disabled ? fieldValidation.disabled : false}
        value={value}
        onKeyDown={handleOnKeyDown}
        showFractions={fieldValidation.showFractions === false
          ? fieldValidation.showFractions : true}
      />
      {fieldValidation.disabled && (
        <input type="hidden" id={fieldId} name={fieldId} value={value} />
      )}
      {
        validationErrState.validationErr
        && (
          <div id="alert-error" className={cssProperties.validationErrorStyle ? cssProperties.validationErrorStyle : 'alert dls-color-warning pad-1-t col-md-12'}>
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{validationErrState.validationErr}</span>
          </div>
        )
      }
    </div>
  );
};

Currency.propTypes = {
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  filledFormData: PropTypes.string,
  onElementChange: PropTypes.string,
  handleOnChangeEvents: PropTypes.string,
  fieldPlaceholder: PropTypes.string,
  fieldId: PropTypes.string,
  fieldValue: PropTypes.string,
  getValue: PropTypes.func,
  preFilledWith: PropTypes.string,
  fetchUrl: PropTypes.string,
  selectKey: PropTypes.string,
  isPreFilled: PropTypes.string,
  setCurrencySymbol: PropTypes.func,
  setValidationErrors: PropTypes.func,
  validationErrors: PropTypes.objectOf(PropTypes.shape),
  validations: PropTypes.arrayOf(PropTypes.shape),
  setFocus: PropTypes.func,
  fieldRank: PropTypes.number,
  extractMapResponseValueByKey: PropTypes.string,
  dataObject: PropTypes.objectOf(PropTypes.shape),
};

export default Currency;
